module.exports = __webpack_public_path__ + "img/10_of_Spades.svg.9ef25f3e.png";